const windowHeight = window.innerHeight;

export default () => {
  const scrollTop = window.scrollY;
  let alpha = (scrollTop / windowHeight) * 2;
  alpha = Math.min(1, alpha);
  document.getElementsByClassName(
    'navbar-theme',
  )[0].style.backgroundColor = `rgba(11, 23, 39, ${alpha})`;
};
